import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useUpgradePaywall } from '../../hooks/useUpgradePaywall';
export const LoggedInMobileUpgradePaywall = _ref => {
  let {
    onUpgradeContinue
  } = _ref;
  const {
    search
  } = useLocation();
  const params = new URLSearchParams(search);
  const domainName = params.get('domainName') ?? '';
  const msid = params.get('msid') ?? undefined;
  const siteName = params.get('siteName') ?? undefined;
  const action = params.get('action') === 'assign' ? 'assign' : 'connect';
  if (!domainName) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/results"
    });
  }
  return /*#__PURE__*/React.createElement(LoggedInMobileUpgradePaywallContent, {
    domainName: domainName,
    msid: msid,
    siteName: siteName,
    action: action,
    onUpgradeContinue: onUpgradeContinue
  });
};
const LoggedInMobileUpgradePaywallContent = _ref2 => {
  let {
    domainName,
    msid,
    siteName,
    action,
    onUpgradeContinue
  } = _ref2;
  useUpgradePaywall({
    layout: 'fullscreen',
    domainName,
    siteName,
    onUpgrade: () => onUpgradeContinue == null ? void 0 : onUpgradeContinue({
      domainName,
      msid,
      action
    })
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
//# sourceMappingURL=LoggedInMobileUpgradePaywall.js.map